import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SettingsClientCustomCrudComponent} from '../components/crud/settings-client-custom-crud.component';


/**
 * Service for opening the CRUD modal.
 */
@Injectable()
export class SettingsClientCustomCrudService {
  /**
   * Injects dependencies.
   *
   * @param modal
   */
  public constructor(
    private modal: NgbModal
  ) {
  }

  /**
   * Opens the CRUD modal for create or edit.
   *
   * @param uid optional uid for edit mode
   */
  public openModal(uid?: string) {
    const modalRef = this.modal.open(SettingsClientCustomCrudComponent, <any>{size: 'lg', backdrop: 'static'});
    uid && modalRef.componentInstance.load(uid);
  }
}
